import { ThemeType } from '@app/interfaces/interfaces';
import { createSlice, createAction, PrepareAction } from '@reduxjs/toolkit';

interface ThemeState {
  theme: ThemeType;
  siderWidth: number;
}

export const defaultTheme = (localStorage.getItem('theme') as ThemeType) || 'light';

localStorage.setItem('theme', defaultTheme);

const initialState: ThemeState = {
  theme: defaultTheme,
  siderWidth: 0,
};

export const setTheme = createAction<PrepareAction<ThemeType>>('theme/setTheme', (theme: ThemeType) => {
  localStorage.setItem('theme', theme);
  return {
    payload: theme,
  };
});

export const setSiderWidth = createAction<PrepareAction<number>>('theme/setSiderWidth', (width: number) => {
  return {
    payload: width,
  };
});

export const themeSlice = createSlice({
  name: 'theme',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(setTheme, (state, action) => {
      state.theme = action.payload;
    });
    builder.addCase(setSiderWidth, (state, action) => {
      state.siderWidth = action.payload;
    });
  },
});

export default themeSlice.reducer;
